import { Link } from "react-router-dom";
import { CONTACT } from "./shared";

export const Footer = () => (
  <footer className="border-t border-white/10 bg-encre py-16" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-5 lg:px-10">
      <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <div>
            <img
              src="/assets/logo-dark.webp"
              alt="Rosset Conciergerie & Services"
              className="h-auto w-72 max-w-full sm:w-96"
            />
          </div>
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-white/50">
            Conciergerie, entretien d'immeubles et PPE, nettoyages professionnels et
            petits travaux — Sion et Valais central.
          </p>
          <p className="mt-4 text-[11px] uppercase tracking-[0.2em] text-white/30">
            Une entreprise de Rosset Solutions
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-lagoon">Contact</p>
          <div className="mt-5 space-y-3 text-sm text-white/70">
            <a href={CONTACT.phoneHref} data-testid="footer-phone" className="block transition-colors duration-300 hover:text-lagoon">{CONTACT.phone}</a>
            <a href={`mailto:${CONTACT.email}`} data-testid="footer-email" className="block break-all transition-colors duration-300 hover:text-lagoon">{CONTACT.email}</a>
            <p>{CONTACT.address}</p>
            <a href="https://rossetconciergerie.ch" data-testid="footer-website" className="block transition-colors duration-300 hover:text-lagoon">{CONTACT.site}</a>
          </div>
        </div>
        <div className="md:col-span-2">
          <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-lagoon">Services</p>
          <div className="mt-5 space-y-3 text-sm text-white/70">
            <Link to="/entretien-immeubles-ppe" data-testid="footer-link-ppe" className="block transition-colors duration-300 hover:text-lagoon">Entretien d'immeubles &amp; PPE</Link>
            <Link to="/nettoyage-professionnel" data-testid="footer-link-nettoyage" className="block transition-colors duration-300 hover:text-lagoon">Nettoyage professionnel</Link>
            <Link to="/nettoyage-haute-pression" data-testid="footer-link-pression" className="block transition-colors duration-300 hover:text-lagoon">Nettoyage haute pression</Link>
            <Link to="/travaux-entretien" data-testid="footer-link-travaux" className="block transition-colors duration-300 hover:text-lagoon">Petits &amp; moyens travaux</Link>
            <Link to="/debarras" data-testid="footer-link-debarras" className="block transition-colors duration-300 hover:text-lagoon">Débarras &amp; évacuation</Link>
            <Link to="/contact" data-testid="footer-link-devis" className="block transition-colors duration-300 hover:text-lagoon">Demander un devis</Link>
          </div>
        </div>
        <div className="md:col-span-2">
          <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-lagoon">Informations</p>
          <div className="mt-5 space-y-3 text-sm text-white/70">
            <Link to="/mentions-legales" data-testid="footer-link-mentions" className="block transition-colors duration-300 hover:text-lagoon">Mentions légales</Link>
            <Link to="/politique-confidentialite" data-testid="footer-link-confidentialite" className="block transition-colors duration-300 hover:text-lagoon">Politique de confidentialité</Link>
          </div>
        </div>
      </div>
      <div className="mt-14 flex flex-col gap-2 border-t border-white/10 pt-6 text-[11px] uppercase tracking-[0.15em] text-white/30 sm:flex-row sm:items-center sm:justify-between">
        <span>© {new Date().getFullYear()} Rosset Conciergerie &amp; Services — Sion, Valais</span>
        <span>Propre. Soigné. Sans complication.</span>
      </div>
    </div>
  </footer>
);
